import InvoicePDF from './InvoicePDF';
import InvoiceThirdPDF from './InvoiceThirdPDF';
import InvoiceThirdPDFComercial from './InvoiceThirdPDFComercial';
import moment from 'moment';

export class InvoiceUtils {

    constructor() {

    }

    checkStatus(response) {
        switch (response.status) {
            case 500:
                throw new Error(`${response.status} - Server Error!`);
            case 403:
                throw new Error(`${response.status} - Unauthenticated!`);
            case 404:
                throw new Error(`${response.status} - Not Found!`);
            default:
                break;
        }
    }

    //En caso de que necesite extraer los recibos de caja
    extractIdForReceipts(invoice) {
        let ids = [];
        for (let i = 0; i < invoice.servicios?.recibos_caja.length; i++) {
            ids[i] = invoice.servicios?.recibos_caja[i].id;
        }
        return ids;
    }

    //Consulta una Previsualizacion de la Factura
    async getReceiptsById(ids, id_tercero, num_fac_ter, nota_credito) {
        let data;
        let dataSend = {
            id_recibos: ids,
            id_tercero: id_tercero,
            id_clinica: parseInt(sessionStorage.getItem('id_clinica')),
            num_fac_ter: num_fac_ter,
            nota_credito: nota_credito != undefined && nota_credito != null && nota_credito != "" ? nota_credito : null
        };
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/previsualizar-factura', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            return response.json();
        }).then(res => {
            data = res;
        }).catch((error) => {
            console.error(error);
            throw new Error(error);
        });
        return data;
    }

    //Genera el PDF de la Previsualizacion de la Factura cuando es de un particular
    generatePDFPrevisualization(preInvoice, esFactura) {
        let dataSend = {
            num_fac_ter: preInvoice.facturaNumero.num_fac_ter,
            nombre_facturado: preInvoice.facturado.nombre,
            num_documento: preInvoice.facturado.identificacion,
            direccion: preInvoice.facturado.direccion,
            ciudad: preInvoice.facturado.ciudad,
            telefono: preInvoice.facturado.telefono,
            correo: preInvoice.facturado.correo,
            fecha_emision: preInvoice.emision,
            vigencia: preInvoice.vigencia,
            copago: preInvoice.totalCopagos,
            total: preInvoice.totalRecibosCostos,
            neto: preInvoice.totalFactura,
            items: preInvoice.items,
            urlDian: preInvoice.url_dian,
            profile: preInvoice.clinica,
            cufe: preInvoice.cufe,
            autorizacion_text: preInvoice.autorizacion_text,
            esFactura: esFactura,
            tercero: preInvoice.tercero,
            recibosCaja: preInvoice.recibosCaja,
            facturado: preInvoice.facturado,
            nota: preInvoice.nota,
            fecha_ingreso: preInvoice.recibosCaja[0].fecha
        };
        InvoicePDF(dataSend);
    }

    //Genera el PDF de la Previsualizacion de la Factura cuando es de un tercero
    generatePDFPrevisualizationInvoices(preInvoice, esFactura, noteInvoiceFromPrevisualizationForm) {
        let noteInvoice = !!noteInvoiceFromPrevisualizationForm ? noteInvoiceFromPrevisualizationForm : !!preInvoice.nota ? preInvoice.nota : !!preInvoice.tercero.nota_factura ? preInvoice.tercero.nota_factura : "" ;
        let dataSend = {
            num_fac_ter: preInvoice.facturaNumero.num_fac_ter,
            nombre_facturado: preInvoice.facturado.nombre,
            num_documento: preInvoice.facturado.identificacion,
            direccion: preInvoice.facturado.direccion,
            ciudad: preInvoice.facturado.ciudad,
            telefono: preInvoice.facturado.telefono,
            correo: preInvoice.facturado.correo,
            fecha_emision: preInvoice.emision,
            vigencia: preInvoice.vigencia,
            copago: preInvoice.totalCopagos,
            total: preInvoice.totalRecibosCostos,
            neto: preInvoice.totalFactura,
            items: preInvoice.items,
            urlDian: preInvoice.url_dian,
            profile: preInvoice.clinica,
            cufe: preInvoice.cufe,
            autorizacion_text: preInvoice.autorizacion_text,
            esFactura: esFactura,
            tercero: preInvoice.tercero,
            recibosCaja: preInvoice.recibosCaja,
            facturado: preInvoice.facturado,
            nota: noteInvoice
        };
        InvoiceThirdPDF(dataSend);
    }

     //Consulta la Factura comercial
     async getComercialInvoice(id_factura_t) {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'facturas/get-comercial-invoice?id_factura_t=' + id_factura_t, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(res => {
            this.generatePDFComercialInvoice(res.factura,res.clinica,res.autorizacion_text,res.cufe,res.url_dian);
        }).catch((error) => {
            console.log(error);
            throw new Error(error);
        });
    }

    generatePDFComercialInvoice(invoice,clinic,autorization_text,cufe,url_dian) {
        let dataSend = {
            num_fac_ter: invoice.num_fac_ter,
            nombre_facturado: invoice.detalles_comerciales.cliente.name,
            num_documento: invoice.detalles_comerciales.cliente.num_document,
            direccion: invoice.detalles_comerciales.cliente.adress,
            ciudad: invoice.detalles_comerciales.cliente.city_name,
            telefono: invoice.detalles_comerciales.cliente.phone != null && invoice.detalles_comerciales.cliente.phone != undefined ? invoice.detalles_comerciales.cliente.phone : "",
            correo: invoice.detalles_comerciales.cliente.email != null && invoice.detalles_comerciales.cliente.email != undefined ? invoice.detalles_comerciales.cliente.email : "",
            vigencia: invoice.vigencia,
            copago: invoice.detalles_comerciales.copago,
            total: invoice.detalles_comerciales.subtotal,
            neto: invoice.detalles_comerciales.total,
            items: invoice.items.items,
            urlDian: url_dian,
            profile: clinic,
            cufe: cufe,
            fecha_emision: moment(invoice.fecha_emision).format("DD/MM/YYYY"),
            autorizacion_text: autorization_text,
            esFactura:true
        };

        InvoiceThirdPDFComercial(dataSend);
    }

}